<template>
  <div class="page-wrapper">
    <div :class="['header-wrap style1', { sticky: isSticky }]">
      <div class="header-top">
        <div class="container">
          <TopHeader />
        </div>
      </div>
      <NavbarTwo />
    </div>

    <div class="content-wrapper">
      <PageBanner pageTitle="Terms Of Service" mainTitle="Terms Of Service" />
      <PrivacyPolicy />
    </div>
    <MainFooter />
  </div>
</template>

<script>
import TopHeader from "../Layouts/TopHeader.vue";
import NavbarTwo from "../Layouts/NavbarTwo.vue";
import PageBanner from "../Common/PageBanner.vue";
import PrivacyPolicy from "../PrivacyPolicy/PrivacyPolicy.vue";
import MainFooter from "../Layouts/MainFooter.vue";

import { defineComponent } from "vue";

export default defineComponent({
  name: "TermsOfServicePage",
  components: {
    TopHeader,
    NavbarTwo,
    PageBanner,
    PrivacyPolicy,
    MainFooter,
  },
  data() {
    return {
      isSticky: false,
    };
  },
  mounted() {
    window.addEventListener("scroll", () => {
      let scrollPos = window.scrollY;
      if (scrollPos >= 100) {
        this.isSticky = true;
      } else {
        this.isSticky = false;
      }
    });
  },
});
</script>